@include host-component-properties;

:host {
  display: block;

  --paf-pearl-chain-time-walk-icon-size: 24;
  --paf-pearl-chain-time-walk-text-size: 12;
}

.paf-result-pearl-chain-time {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  align-items: center;
  column-gap: px-to-rem(var(--paf-global-spacing-fixed-2x));
  position: relative;

  &.loading * {
    opacity: 0;
  }

  .loader {
    @include skeleton-loading;

    right: 40%;
  }

  p {
    margin: 0;
    line-height: 1;
  }
}

.paf-result-pearl-chain-time__arrival-walk-text,
.paf-result-pearl-chain-time__departure-walk-text,
.paf-result-pearl-chain-time__arrival-wheelchair-text,
.paf-result-pearl-chain-time__departure-wheelchair-text {
  display: inherit;
  align-items: inherit;
  font-size: px-to-rem(var(--paf-pearl-chain-time-walk-text-size));
}

.paf-result-pearl-chain-time__arrival-walk-icon,
.paf-result-pearl-chain-time__departure-walk-icon,
.paf-result-pearl-chain-time__arrival-wheelchair-icon,
.paf-result-pearl-chain-time__departure-wheelchair-icon {
  width: px-to-rem(var(--paf-pearl-chain-time-walk-icon-size));
  height: px-to-rem(var(--paf-pearl-chain-time-walk-icon-size));

  @include forced-colors {
    fill: currentcolor;
  }
}

.paf-result-pearl-chain-time__arrival,
.paf-result-pearl-chain-time__departure {
  display: inherit;
  flex-wrap: inherit;
  align-items: inherit;
  column-gap: px-to-rem(var(--paf-global-spacing-fixed-2x));
}

.paf-result-pearl-chain-time__arrival-time,
.paf-result-pearl-chain-time__departure-time {
  font-weight: bold;
}

::slotted(paf-result-pearl-chain) {
  flex: 1 1 100%;

  .loading & {
    display: none;
  }
}
